import CharCustom from "../chartCustom";
import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import axiosService from "../../../../../services/axiosService";
import {CONFIG} from "../../../../../configs";

function Sample() {
  const { t } = useTranslation();
  const [chartData, setChartData] = useState([])
  const [data, setData] = useState([])

  useEffect(() => {
    getChartData()
    getTableData()

    let id = setInterval( () => {
      getChartData()
      getTableData()
    }, 60000);
    return () => clearInterval(id);
  }, [])

  const getChartData = async () => {
    const {data: dataApi} = await axiosService.get(`${CONFIG.API_URL.BASE}/api/samples/count-by-type`)
    const result = (dataApi || []).map(chart => ({type: chart.name || '', count: chart.data}))
    setChartData(result)
    // console.log(result)
  }

  const getTableData = async () => {
    const {data: dataAPi} = await axiosService.get(`${CONFIG.API_URL.BASE}/api/samples/count-by-type-and-status`)
    // console.log(dataAPi)
    generateTable(dataAPi || [])
  }

  const generateTable = (dataAPi) => {
    const tableContent = []
    for (let i = 0; i < dataAPi.length; i++) {
      const item = dataAPi[i]
      const { sampleCountByStatusList } = item
      const firstRowSpan = sampleCountByStatusList.length
      tableContent.push(
        <tr key={i}>
          <td rowSpan={firstRowSpan}>{item.sampleType}</td>
          <td>{t('SAMPLE.' + sampleCountByStatusList[0].status)}</td>
          <td>{sampleCountByStatusList[0].count}</td>
        </tr>
      )

      for (let j = 1; j < sampleCountByStatusList.length; j++) {
        const sampleCountByStatus = sampleCountByStatusList[j]
        tableContent.push(
          <tr key={'sampleCountByStatus' + i + j}>
            <td>{t('SAMPLE.' + sampleCountByStatus.status)}</td>
            <td>{sampleCountByStatus.count}</td>
          </tr>
        )
      }
    }
    setData(tableContent)
  }

  return (
    <div className="dashboard-tile-table-class">
      <div className="div_title_header" span={24}>
        <div className="tw-inline-flex">
          <img
            className="img_tilte"
            src="/images/sample_management.png"
            align="top"
            alt=""
          />
          <strong>&nbsp;&nbsp;{t("DASHBOARD.sample")}</strong>
        </div>
        <div className="tw-flex-row tw-flex">
          <div className="canvas-container-class" span={12}>
            <CharCustom data={chartData} />
          </div>
          <div>
            <table className="table-standard-border" width="100%">
              <thead>
                <tr style={{ background: "#1C5B75", color: "#fff" }}>
                  <td width="45%">{t("SAMPLE.type")}</td>
                  <td width="37%">{t("SAMPLE.status")}</td>
                  <td width="10%">{t("SAMPLE.count")}</td>
                </tr>
              </thead>
              <tbody>{data}</tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Sample;
